import { axiosPost, axiosGet, axiosPut } from '@/api/AxiosApi';

// 핀 번호 체크
export const chkPin = async (pinNum: string) => {
  const payload = {
    path: `/v1/users/pin?pin_num=${pinNum}`,
  };
  const { data: re } = await axiosGet(payload);
  return re;
};
type sendEamilAuthProps = {
  email: string;
  emailAuthNo: string;
};
// 이메일 인증번호 발송
export const sendEamilAuth = async (aData: sendEamilAuthProps) => {
  const payload = {
    path: '/v1/users/changepw/contact',
    body: { ...aData },
  };
  const { data: re } = await axiosPost(payload);
  return re;
};

// 이메일, 인증번호 체크
type checkAuthNoProps = {
  email: string;
  email_auth_no: string;
};
export const checkAuthNo = async (aData: checkAuthNoProps) => {
  const payload = {
    path: '/v1/users/changepw',
    body: { ...aData },
  };
  const { data: re } = await axiosPost(payload);
  return re;
};

// 이메일 인증 후 비밀번호 변경
type updatePwByEmailProps = {
  email: string;
  email_auth_no: string;
  user_pw: string;
};
export const updatePwByEmail = async (aData: updatePwByEmailProps) => {
  const payload = {
    path: '/v1/users/changepw',
    body: { ...aData },
  };
  const { data: re } = await axiosPut(payload);
  return re;
};

// 핀 번호 잊어버린 후 이메일 인증 번호로 핀 번호 설정
type resetPinNumProps = {
  email: string;
  email_auth_no: string;
  pin_num: string;
};
export const resetPinNum = async (aData: resetPinNumProps) => {
  const payload = {
    path: '/v1/users/pinnum',
    body: { ...aData, country: 82 },
  };
  const { data: re } = await axiosPut(payload);
  return re;
};
// 비밀번호 변경
